// Lib
import { FC, useEffect, useMemo, useState } from "react";
// Api
import { useGetLoyaltyQuery } from "rtkQuery/query/loyaltyAPI";
// Hooks
import { useNotification, useViewport } from "hooks";
// Types
import { Loyalty } from "types/loyalty";
// Constants
import { rtkQueryParams } from "consts";
// Utils
import { errorHandler } from "utils/errorHandler";
// Icons
import { DescriptionBlackIcon } from "icons";
// Components
import { Table } from "components";
import { LoyaltyUsersModal } from "../components";
// Styled
import { FlexContainer, PageWrapper } from "styled/Box";
import { Typography } from "styled/Typography";
import { Button } from "styled/Buttons";

import { columns } from "./config";

export const LoyaltyTiers: FC = () => {
  const { isDesktop } = useViewport();

  const { openNotification } = useNotification();

  const [loyaltyUsers, setLoyaltyUsersUsers] = useState({
    id: "",
    name: "",
  });

  const { data, isFetching, error } = useGetLoyaltyQuery(null, rtkQueryParams);

  useEffect(() => {
    if (error) {
      errorHandler({ error, openNotification });
    }
  }, [error]);

  const onCounterClick = (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    count: number,
    id: string,
    name: string,
  ) => {
    e.preventDefault();
    e.stopPropagation();

    if (!count) {
      return;
    }
    setLoyaltyUsersUsers({
      id,
      name,
    });
  };

  const tableColumns = useMemo(() => {
    return columns.map(col => {
      if (col.key === "usersCount") {
        return {
          ...col,
          render: (count: number, record: Loyalty) => (
            <Button.Notification
              type="link"
              onClick={e => {
                onCounterClick(e, count, record.id, record?.name);
              }}
            >
              {count}
            </Button.Notification>
          ),
        };
      }

      return col;
    });
  }, []);

  return (
    <>
      <PageWrapper $fullwidth $column>
        <FlexContainer
          $fullwidth
          $column
          $grow={1}
          $padding={isDesktop && "0 0 32px"}
        >
          <FlexContainer
            $padding="0 0 24px"
            $align="center"
            $justify="space-between"
          >
            <Typography.H1>Loyalty Tiers</Typography.H1>
          </FlexContainer>

          <Table
            isLoading={isFetching}
            withPagination={!isDesktop}
            dataSource={data || []}
            columns={tableColumns}
            empty={{
              icon: DescriptionBlackIcon,
              title: "No Tiers to show.",
            }}
            header={{
              totalCount: data?.length,
              suffix: <div style={{ height: 40 }} />,
            }}
          />
        </FlexContainer>
      </PageWrapper>

      <LoyaltyUsersModal
        loyaltyUsers={loyaltyUsers}
        setLoyaltyUsersUsers={setLoyaltyUsersUsers}
      />
    </>
  );
};
